export function getUserGroups(user) {
  const rawGroups = user?.['cognito:groups'];

  if (Array.isArray(rawGroups)) {
    return rawGroups.filter(Boolean);
  }

  if (typeof rawGroups === 'string') {
    const trimmed = rawGroups.trim();
    if (!trimmed) {
      return [];
    }

    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.filter(Boolean);
        }
      } catch (error) {
        return trimmed
          .slice(1, -1)
          .split(/[\s,]+/)
          .map((value) => value.trim())
          .filter(Boolean);
      }
    }

    return trimmed
      .split(/[\s,]+/)
      .map((value) => value.trim())
      .filter(Boolean);
  }

  return [];
}

export function isAmxAdmin(user) {
  return getUserGroups(user).includes('amx-admin');
}

export function isAmxUser(user) {
  return getUserGroups(user).includes('amx-user');
}

export function isPartnerAdmin(partnerProfile) {
  const memberships = Array.isArray(partnerProfile?.memberships) ? partnerProfile.memberships : [];
  return memberships.some((membership) => membership?.role === 'partner_admin');
}

export function requiresPartnerOnboarding(partnerProfile) {
  return Boolean(partnerProfile?.onboarding?.required && partnerProfile?.onboarding?.next_required_step);
}
